<template>
  <div class="inline-block mt-[25px]" ref="gameItemRef">
    <div class="game-item relative p-[5px]" :class="{ 'h-[140px]': !props.height }" :style="{ height: props.height ? props.height : '' }">
      <div v-if="props.mockHotGame"
        class="absolute w-[80%] top-0 left-1/2 transform -translate-x-1/2 translate-y-[25%] z-2">
        <div class="relative" ref="mockHotGameRef">
          <img :src="getAssetsFile('game/mockHotGameNumberTitle.png')"
            class="h-16px w-auto absolute left-1/2 transform -translate-x-1/2 translate-y-[-50%] z-2" alt="">
          <img :src="getAssetsFile('game/mockHotGameNumberBg.png')" alt="" class="w-full h-[19px]">
          <div
            class="absolute top-0 left-0 w-full h-full flex items-center justify-center z-2  transform -translate-y-[12.5%] text-[12px] text-[#FFFC11]">
            {{ numberFormat(mockHotGameNumber) }}
          </div>
        </div>
      </div>

      <div class="w-full h-full relative z-1 p-[4px] shadow-lg shadow-[#00000060] rounded-[16px]"
        @click="goGame(props.game)">
        <!-- <div class="w-full h-full absolute top-0 left-0 z-1"
          :class="{ 'slide-mask': props.showHot && !props.mockHotGame && props.game.tag == 1 }">

        </div> -->
        <img :src="props.game.imageSquare" alt="" class="relative z-1 w-full h-full object-cover " />
        <img :src="getAssetsFile('game/gamePopBg.png')" alt="" srcset=""
          class="absolute top-[2px] left-[2px] z-2 w-[calc(100%-2px)] h-[calc(100%-3px)] rounded-[16px]">
        <img :src="getAssetsFile('game/gameBg.png')" alt=""
          class="w-[calc(100%+2px)] h-[calc(100%+2px)] transform translate-x-[-1px] translate-y-[-1px] absolute top-0 left-0 z-3" />
      </div>
      <img v-if="props.showHot && !props.mockHotGame && props.game.tag == 1" :src="getAssetsFile('game/hotIcon.gif')"
        alt="" class="z-2 w-[40px] h-[40px] absolute -top-6px -left-2px transform -translate-y-1/5 -translate-x-1/5">
      <img v-trans="{
        type: 'heartbeat',
        scale: 1.2,
        duration: 100
      }" v-if="props.showFavorite && props.game.collect" :src="getAssetsFile('game/inFavoriteIcon.png')" alt=""
        class="z-2 w-[30px] h-[30px] absolute -bottom-4px -left-2px" @click.stop="uncollect">
      <img v-trans="{
        type: 'heartbeat',
        scale: 1.2,
        duration: 100
      }" v-if="props.showFavorite && !props.game.collect" :src="getAssetsFile('game/noFavoriteIcon.png')" alt=""
        class="z-2 w-[30px] h-[30px] absolute -bottom-4px -left-2px " @click.stop="collect">
    </div>
  </div>
</template>

<script setup lang="ts">
import { Border } from "@/components/Border";
import { getAssetsFile } from '@/utils/pub-use';
import * as GameApi from '@/api/game'
import { useUserStore } from '@/stores'
import { useRoute, useRouter } from 'vue-router'
import { trackHomeClickGameEntryIcon } from '@/utils/firebase-analytics'
import { numberFormat } from '@/utils/formatter'
import { onMounted, onUnmounted, ref, nextTick, watch } from 'vue'

/**
 * 生成指定范围内的随机整数
 * @param min 最小值（包含）
 * @param max 最大值（包含）
 * @returns 范围内的随机整数
 */
const getRandomInt = (min: number, max: number): number => {
  // 确保 min 和 max 是整数
  const minInt = Math.ceil(min)
  const maxInt = Math.floor(max)
  // 确保 min 小于 max
  if (minInt > maxInt) {
    throw new Error('最小值不能大于最大值')
  }
  // 生成随机整数，包含 min 和 max
  return Math.floor(Math.random() * (maxInt - minInt + 1)) + minInt
}

const userStore = useUserStore()
const isLogin = computed(() => userStore.isLoggedIn);
const route = useRoute()
const router = useRouter()
// 初始值设为 0，等元素出现在视野中时再设置随机值

const VITE_PLATFORM = import.meta.env.VITE_PLATFORM
const props = defineProps<{
  height?: string
  // 显示收藏按钮
  showFavorite?: boolean
  // 显示热门图标
  showHot?: boolean
  // 模拟热点游戏数据
  mockHotGame?: boolean
  // 游戏数据
  game: {
    id: number
    categoryCode: string
    collect: string
    columnId: string
    currencyCode: string
    gameCode: string
    gameName: string
    imageLandscape: string
    imageSquare: string
    languageCode: string;
    platformCode: string;
    providerId: number;
    updateTime: number;
    vendorIcon: string;
    vendorId: number;
    vendorName: string;
    tag: number;
  }
}>()
const mockHotGameNumber = ref(0)
const mockHotGameRef = ref<HTMLElement | null>(null)
const gameItemRef = ref<HTMLElement | null>(null)
let intersectionObserver: IntersectionObserver | null = null
let hasTriggered = false // 标记是否已经触发过
let animationFrameId: number | null = null // 动画帧 ID

/**
 * 数字滚动动画函数
 * @param startValue 起始值
 * @param endValue 结束值
 * @param duration 动画时长（毫秒）
 */
const animateNumber = (startValue: number, endValue: number, duration: number = 300) => {
  // 如果已经有动画在进行，先取消
  if (animationFrameId !== null) {
    cancelAnimationFrame(animationFrameId)
  }

  const startTime = performance.now()

  const animate = (currentTime: number) => {
    const elapsed = currentTime - startTime
    const progress = Math.min(elapsed / duration, 1) // 进度 0-1

    // 使用 easeOut 缓动函数，让动画更自然
    const easeOut = (t: number) => {
      return 1 - Math.pow(1 - t, 3)
    }

    const easedProgress = easeOut(progress)
    const currentValue = Math.floor(startValue + (endValue - startValue) * easedProgress)

    mockHotGameNumber.value = currentValue

    if (progress < 1) {
      animationFrameId = requestAnimationFrame(animate)
    } else {
      // 动画结束，确保最终值为目标值
      mockHotGameNumber.value = endValue
      animationFrameId = null
    }
  }

  animationFrameId = requestAnimationFrame(animate)
}

const start = () => {
  // 如果 mockHotGameNumber 为 0 或未设置，先设置一个随机值
  if (!mockHotGameNumber.value || mockHotGameNumber.value === 0) {
    const targetValue = getRandomInt(10000, 99999)

    // 先重置为 0，然后启动动画从 0 递增到目标值
    mockHotGameNumber.value = 0

    // 等待 DOM 更新后启动动画
    nextTick(() => {
      animateNumber(0, targetValue, 1500)
    })
  } else {
    nextTick(() => {
      animateNumber(0, mockHotGameNumber.value, 1500)
    })

  }
};
const emit = defineEmits<{
  (e: 'update:game', game?: any): void
}>()
const collectTimer = ref(null)
const collect = async () => {
  try {
    if (!isLogin.value) {
      window.$showLoginDialog()
      return
    }
    if (collectTimer.value) {
      return
    }
    collectTimer.value = setTimeout(async () => {
      await GameApi.collect({ gameId: props.game.id })
      await getGame()
      collectTimer.value = null
    }, 100)
  } catch (error) {
    console.error('收藏失败:', error)
  }

}
const uncollectTimer = ref(null)
const uncollect = async () => {
  try {
    if (!isLogin.value) {
      window.$showLoginDialog()
      return
    }
    if (uncollectTimer.value) {
      return
    }
    uncollectTimer.value = setTimeout(async () => {
      await GameApi.uncollect({ gameId: props.game.id })
      await getGame()
      uncollectTimer.value = null
    }, 100)
  } catch (error) {
    console.error('取消收藏失败:', error)
  }
}

const getGame = async () => {
  // const res = await GameApi.getGame([props.game.id])
  // console.log(res.data, "res.data")
  emit('update:game')
}
const goGame = async (game: any) => {
  trackHomeClickGameEntryIcon()
  const a = userStore.checkLoginStatus()
  if (a) {
    const gamesid = {
      platformId: game.providerId,
      currency: VITE_PLATFORM,
      disableFullScreen: 0,
      gameId: game.gameCode,
      lang: 'en',
      homeUrl: import.meta.env.VITE_BASE_URL || window.location.origin,
      platform: 'H5',
      id: game.id,
    }
    const gameUrl = await GameApi.thirdPartygoGame(gamesid)
    // 记录来源路径
    sessionStorage.setItem('fromPath', route.path)
    // 使用 query 参数传递 URL
    router.push({
      path: '/webview/index2',
      query: {
        rid: gameUrl.data,
      },
    })
  } else {
    // 未登录时，检查是否有 jumpUrlType 参数
    const jumpUrlType = route.query.jumpUrlType || sessionStorage.getItem('jumpUrlType')

    if (jumpUrlType == '1') {
      // jumpUrlType 为 1 时，用户点击游戏时弹出注册弹窗
      const inviteCode = route.query.pid as string || ''
      window.$showRegisterDialog(inviteCode) // 使用全局函数
    } else {
      // 其他情况，弹出登录弹窗
      const inviteCode = route.query.pid as string || ''
      window.$showLoginDialog(inviteCode) // 使用全局函数
    }
  }
}
// 检查元素是否已经在视野中
const checkInitialVisibility = () => {
  if (props.mockHotGame && gameItemRef.value) {
    const rect = gameItemRef.value.getBoundingClientRect()
    const isVisible = rect.top < window.innerHeight && rect.bottom > 0 && rect.width > 0 && rect.height > 0

    if (isVisible && !hasTriggered) {
      start()
      hasTriggered = true
    }
  }
}

// 设置 Intersection Observer
const setupIntersectionObserver = () => {
  // 只有在 mockHotGame 为 true 时才执行
  if (!props.mockHotGame) {
    // 如果 mockHotGame 为 false，清理观察器
    if (intersectionObserver) {
      intersectionObserver.disconnect()
      intersectionObserver = null
    }
    return
  }

  // 清理旧的观察器
  if (intersectionObserver) {
    intersectionObserver.disconnect()
    intersectionObserver = null
  }

  // 重置触发标记
  hasTriggered = false

  nextTick(() => {
    // 再次检查 mockHotGame，确保在异步操作期间仍然是 true
    if (!props.mockHotGame) {
      return
    }

    // 检查初始可见性
    checkInitialVisibility()

    // 使用 gameItemRef 作为观察目标，因为它更稳定
    const targetElement = gameItemRef.value

    // 元素存在时才设置监听
    if (targetElement) {


      intersectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {


            // 当元素出现在视野中时
            if (entry.isIntersecting && !hasTriggered) {
              // 检查 mockHotGameNumber 是否存在或等于0
              if (!mockHotGameNumber.value || mockHotGameNumber.value === 0) {

                start()
                hasTriggered = true
                // 触发后停止观察（可选）
                if (intersectionObserver) {
                  intersectionObserver.disconnect()
                  intersectionObserver = null
                }
              } else {

              }
            }
          })
        },
        {
          // 当元素至少 10% 可见时触发
          threshold: 0.1,
          // 可以设置 rootMargin 来提前或延后触发
          rootMargin: '0px'
        }
      )

      intersectionObserver.observe(targetElement)

    } else {
    }
  })
}

// 监听 props.mockHotGame 的变化
watch(() => props.mockHotGame, (newVal) => {
  if (newVal) {
    setupIntersectionObserver()
  } else {
    // 如果 mockHotGame 变为 false，清理观察器
    if (intersectionObserver) {
      intersectionObserver.disconnect()
      intersectionObserver = null
    }
  }
})

onMounted(() => {
  // 只有在 props.mockHotGame 为 true 时才设置监听
  if (props.mockHotGame) {
    setupIntersectionObserver()
  }
})

onUnmounted(() => {
  // 清理观察器
  if (intersectionObserver) {
    intersectionObserver.disconnect()
    intersectionObserver = null
  }
  // 清理动画
  if (animationFrameId !== null) {
    cancelAnimationFrame(animationFrameId)
    animationFrameId = null
  }
})
</script>

<style lang="scss" scoped>
.slide-mask {
  position: absolute;
  top: 0;
  left: -200%;
  width: 150%;
  height: 120%;
  /* 从左上到右下的斜梯形光带 */
  clip-path: polygon(0% 0%, 100% 0%, 60% 100%, 0% 100%);
  background: linear-gradient(360deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.5) 50%,
      rgba(255, 255, 255, 0) 100%);
  pointer-events: none;
  animation: slide-light 5s linear infinite;
  z-index: 10;
  border-radius: 11px;
  /* 添加圆角 */
}

@keyframes slide-light {
  0% {
    left: -150%;
    opacity: 1;
  }

  20% {
    left: 0%;
    /* 滑动完成，只用20%的时间 */
    opacity: 1;
  }

  25% {
    left: 0%;
    opacity: 0;
    /* 蒙层消失 */
  }

  100% {
    left: 0%;
    opacity: 0;
    /* 保持消失状态 */
  }
}
</style>
